import React from 'react';
import type { CurrentLine } from '@/types';

export type CurrentLineData = CurrentLine;

interface ConnectionInfoFormProps {
  currentLine: Partial<CurrentLineData>;
  onChange: (data: Partial<CurrentLineData>) => void;
  showTitle?: boolean;
  title?: string;
  className?: string;
}

const ConnectionInfoForm: React.FC<ConnectionInfoFormProps> = ({
  currentLine,
  onChange,
  showTitle = true,
  title = 'Informazioni Connessione',
  className = ''
}) => {
  const handleFieldChange = (field: keyof CurrentLineData, value: any) => {
    onChange({ [field]: value });
  };

  const handleSpeedChange = (type: 'download' | 'upload', value: number) => {
    onChange({
      maxSpeed: {
        ...(currentLine.maxSpeed || { download: 0, upload: 0, unit: 'Mbps' }),
        [type]: value
      }
    });
  };

  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      {showTitle && (
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
      )}
      
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Operatore
          </label>
          <input
            type="text"
            value={currentLine.operator || ''}
            onChange={(e) => handleFieldChange('operator', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="es. TIM, Vodafone, Fastweb..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tecnologia
          </label>
          <select
            value={currentLine.technology || 'Unknown'}
            onChange={(e) => handleFieldChange('technology', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="Unknown">Non specificato</option>
            <option value="None">Nessuna connessione</option>
            <option value="ADSL">ADSL</option>
            <option value="VDSL">VDSL</option>
            <option value="FTTC">FTTC (Fibra fino al cabinet)</option>
            <option value="FTTH">FTTH (Fibra fino a casa)</option>
            <option value="FWA">FWA (Fixed Wireless)</option>
            <option value="Satellite">Satellite</option>
            <option value="Mobile">Mobile/4G/5G</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Velocità Download (Mbps)
          </label>
          <input
            type="number"
            min="0"
            value={currentLine.maxSpeed?.download || ''}
            onChange={(e) => handleSpeedChange('download', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="es. 20"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Velocità Upload (Mbps)
          </label>
          <input
            type="number"
            min="0"
            value={currentLine.maxSpeed?.upload || ''}
            onChange={(e) => handleSpeedChange('upload', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="es. 5"
          />
        </div>
      </div>

      <div className="mt-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={currentLine.isActivated || false}
            onChange={(e) => handleFieldChange('isActivated', e.target.checked)}
            className="mr-2"
          />
          <span className="text-sm text-gray-700">La linea è attualmente attiva</span>
        </label>
      </div>
    </div>
  );
};

export default ConnectionInfoForm;